import { render, staticRenderFns } from "./extraPoints.vue?vue&type=template&id=0f6e34c9&"
import script from "./extraPoints.vue?vue&type=script&lang=js&"
export * from "./extraPoints.vue?vue&type=script&lang=js&"
import style0 from "./extraPoints.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports